<template>
	<Page v-if="data" ref="page" :slug="data.metadata.slug" :name="data.name" :metadata="data.metadata">
		<Landing v-bind="data" />
	</Page>
</template>

<script setup>
import { Page } from '~/components/core'
import { Landing } from '/components/pages'
import { landing } from '~/sanity/projections'

const query = landing()
const page = ref(null)

const { data, error } = await useSanityQuery(query)

if (error.value) {
	throw showError({
		statusCode: error.value?.statusCode || 500,
		statusMessage: error.value?.message || 'An error occurred',
	})
}

if (!data.value) {
	throw showError({
		statusCode: 404,
		statusMessage: 'Page not found',
	})
}
</script>
